module.exports = __webpack_public_path__ + "img/red-warning-icon.eb7f409b.svg";